import * as Icons from "@phosphor-icons/react";
import { getGlobalStats, getSelectedBusinessId } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Counter from "../Counter";
import DataStatuses from "const/DataStatuses";
import React from "react";
import UiRoutes from "const/UiRoutes";

const TransactionsAwaitingClassificationCounter = () => {
  const { uiTexts, messages } = useSelector(getTextsData);

  const globalStats = useSelector(getGlobalStats);

  const businessId = useSelector(getSelectedBusinessId);

  const {
    transactions: {
      toReconcile: { count = 0 } = {}
    } = {}
  } = globalStats;

  return (
    <Counter
      to={`/${businessId}${UiRoutes.TRANSACTIONS}?status=${DataStatuses.TO_RECONCILE}`}
      theme="royal-blue"
      mainText={count}
      secondaryText={uiTexts.transactions.toLowerCase()}
      description={messages.dashboardTxsNeedClassification}
      icon={Icons.Question}
      loading={!globalStats.transactions} />
  );
};

export default React.memo(TransactionsAwaitingClassificationCounter);
